<template>

    <v-container justify-center>
      <span><router-link :to="{name:'Проекты'}">Проекты</router-link></span> <span>/<b> Вывод средств </b></span>

      <v-divider class="mt-3"></v-divider>
      <h1> Вывод средств </h1>

      <v-layout row wrap my-5>
        <div>
          Вывод средств осуществляется на тот же счет, откуда было пополнение.
        </div>
        <div>
          Для вывода, необходимо заполнить заявку, после обработки которой, будет осуществлен перевод средств.
        </div>
      </v-layout>

    </v-container>
</template>

<script>

export default {
   components:{
  },
    created () {
    },
    mounted () {
    },
    computed: {
    },
    data () {
        return {
        }
    },
    methods: {
      withdraw() {
        console.log('withdraw');

      }
    }
}
</script>

<style scoped>
    /*stylesheets*/
</style>



// WEBPACK FOOTER //
// AccountWithdraw.vue?fb679b60